<template>
  <v-card color="transparent" elevation="0">
    <v-col v-if="!finishedLoading || isFiltering" class="d-flex justify-center flex-grow mt-16">
      <v-progress-circular indeterminate color="white" size="64"></v-progress-circular>
    </v-col>

    <div v-if="finishedLoading && centerData && !isFiltering">
      <v-card dark class="mb-4">
        <v-card-title>
          Gesamtentwicklung
          <v-chip small class="ml-4" color="blue-grey"> ⌀ {{ centerData.totalStats.average }} Mitglieder </v-chip>
        </v-card-title>
        <v-card-subtitle> Analyse der letzten {{ months }} Monate </v-card-subtitle>

        <v-card-text class="pb-0">
          <v-row dense>
            <v-col cols="12" md="3">
              <v-card outlined color="rgba(255, 255, 255, 0.1)">
                <v-card-title class="text-subtitle-1">Letzter Monat</v-card-title>
                <v-card-text>
                  <div class="text-h6">{{ centerData.totalStats.previousMonth.month }}</div>
                  <div>{{ centerData.totalStats.previousMonth.value }} Mitglieder</div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="3">
              <v-card outlined color="rgba(255, 255, 255, 0.1)">
                <v-card-title class="text-subtitle-1">Aktueller Monat</v-card-title>
                <v-card-text>
                  <div class="text-h6 d-flex align-center">{{ centerData.totalStats.currentMonth.ist }} Mitglieder</div>
                  <div>
                    Plan: {{ centerData.totalStats.currentMonth.plan }}
                    <v-chip small class="ml-1" :color="centerData.totalStats.currentMonth.diffPercent >= 0 ? 'success' : 'error'">
                      {{ centerData.totalStats.currentMonth.diffPercent.toFixed(1) }}%
                    </v-chip>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="3">
              <v-card outlined color="rgba(255, 255, 255, 0.1)">
                <v-card-title class="text-subtitle-1">Wachstum (Monat)</v-card-title>
                <v-card-text>
                  <div class="text-h6 d-flex align-center">
                    {{ centerData.totalStats.monthlyGrowth.value }}
                    <v-chip small class="ml-2" :color="centerData.totalStats.monthlyGrowth.percent >= 0 ? 'success' : 'error'">
                      {{ centerData.totalStats.monthlyGrowth.percent.toFixed(1) }}%
                    </v-chip>
                  </div>
                  <div>Vs. Vormonat</div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="3">
              <v-card outlined color="rgba(255, 255, 255, 0.1)">
                <v-card-title class="text-subtitle-1">Wachstum (Gesamt)</v-card-title>
                <v-card-text>
                  <div class="text-h6 d-flex align-center">
                    {{ centerData.totalStats.totalGrowth.value }}
                    <v-chip small class="ml-2" :color="centerData.totalStats.totalGrowth.percent >= 0 ? 'success' : 'error'">
                      {{ centerData.totalStats.totalGrowth.percent.toFixed(1) }}%
                    </v-chip>
                  </div>
                  <div>Im Zeitraum</div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-text>
          <apexchart type="bar" height="350" :options="chartOptions" :series="centerData.returnDataTotal"></apexchart>
        </v-card-text>
      </v-card>

      <v-card dark v-for="(data, key) of centerData.returnData" :key="key" class="mb-4">
        <v-card-title>
          {{ data.center }}
          <v-chip small class="ml-4" color="blue-grey"> ⌀ {{ data.stats.average }} Mitglieder </v-chip>
        </v-card-title>

        <v-card-text class="pb-0">
          <v-row dense>
            <v-col cols="12" md="3">
              <v-card outlined color="rgba(255, 255, 255, 0.1)">
                <v-card-title class="text-subtitle-1">Letzter Monat</v-card-title>
                <v-card-text>
                  <div class="text-h6">{{ data.stats.previousMonth.month }}</div>
                  <div>{{ data.stats.previousMonth.value }} Mitglieder</div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="3">
              <v-card outlined color="rgba(255, 255, 255, 0.1)">
                <v-card-title class="text-subtitle-1">Aktueller Monat</v-card-title>
                <v-card-text>
                  <div class="text-h6 d-flex align-center">{{ data.stats.currentMonth.ist }} Mitglieder</div>
                  <div>
                    Plan: {{ data.stats.currentMonth.plan }}
                    <v-chip small class="ml-1" :color="data.stats.currentMonth.diffPercent >= 0 ? 'success' : 'error'">
                      {{ data.stats.currentMonth.diffPercent.toFixed(1) }}%
                    </v-chip>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="3">
              <v-card outlined color="rgba(255, 255, 255, 0.1)">
                <v-card-title class="text-subtitle-1">Wachstum (Monat)</v-card-title>
                <v-card-text>
                  <div class="text-h6 d-flex align-center">
                    {{ data.stats.monthlyGrowth.value }}
                    <v-chip small class="ml-2" :color="data.stats.monthlyGrowth.percent >= 0 ? 'success' : 'error'">
                      {{ data.stats.monthlyGrowth.percent.toFixed(1) }}%
                    </v-chip>
                  </div>
                  <div>Vs. Vormonat</div>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" md="3">
              <v-card outlined color="rgba(255, 255, 255, 0.1)">
                <v-card-title class="text-subtitle-1">Wachstum (Gesamt)</v-card-title>
                <v-card-text>
                  <div class="text-h6 d-flex align-center">
                    {{ data.stats.totalGrowth.value }}
                    <v-chip small class="ml-2" :color="data.stats.totalGrowth.percent >= 0 ? 'success' : 'error'">
                      {{ data.stats.totalGrowth.percent.toFixed(1) }}%
                    </v-chip>
                  </div>
                  <div>Im Zeitraum</div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-text>
          <apexchart type="bar" height="350" :options="chartOptions" :series="data.series"></apexchart>
        </v-card-text>
      </v-card>
    </div>
  </v-card>
</template>

<script>
import api from "../../../api"
import { mapState } from "vuex"

export default {
  props: {
    datePickerRange: {
      type: Array,
      default: () => [],
    },
    studios: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isFiltering: false, // NEU: Zustand für das Lade-Overlay
      months: 12,
      centers: {},
      finishedLoading: false,
    }
  },
  async created() {
    await this.fetchContractDevelopment()
  },
  methods: {
    async fetchContractDevelopment() {
      this.finishedLoading = false
      try {
        const data = await api.fetchContractDevelopment(this.months)
        this.centers = data.centers
      } catch (error) {
        console.error("Fehler beim Laden der Vertragsdaten:", error)
      } finally {
        this.finishedLoading = true
      }
    },
    calculatePercentageDiff(actual, planned) {
      if (planned === 0 || planned === null) {
        return actual > 0 ? 100.0 : 0.0
      }
      if (actual === planned) {
        return 0.0
      }
      return ((actual - planned) / planned) * 100
    },
  },
  computed: {
    ...mapState("studioStore", ["storeStudios"]),

    chartOptions() {
      const categories = this.centerData ? this.centerData.categories : []
      return {
        chart: {
          type: "bar",
          height: 350,
          foreColor: "#ccc",
          toolbar: { show: false },
        },
        plotOptions: { bar: { horizontal: false, columnWidth: "65%", endingShape: "rounded" } },
        dataLabels: { enabled: false },
        stroke: { show: true, width: 2, colors: ["transparent"] },
        xaxis: { categories: categories },
        yaxis: { title: { text: "Anzahl Mitglieder" } },
        fill: { opacity: 1 },
        grid: { borderColor: "#535A6C" },
        colors: ["#2483af", this.$vuetify.theme.themes.light.primary],
        tooltip: {
          shared: true,
          intersect: false,
          theme: "dark",
          custom: ({ series, seriesIndex, dataPointIndex, w }) => {
            // Annahmen:
            // series[0] sind die "Soll"-Werte
            // series[1] sind die "Ist"-Werte
            const sollWert = series[0][dataPointIndex]
            const istWert = series[1][dataPointIndex]
            const monat = w.globals.labels[dataPointIndex]
            const differenz = istWert - sollWert

            // ====================================================================
            // NEUE LOGIK: Unterschied zum Vormonat berechnen
            // ====================================================================
            let vormonatHtml = ""
            // Die Berechnung ist nur möglich, wenn es einen Vormonat gibt (d.h. nicht für den ersten Datenpunkt)
            if (dataPointIndex > 0) {
              const vormonatIstWert = series[1][dataPointIndex - 1]
              const diffVormonatAbsolut = istWert - vormonatIstWert

              let diffVormonatProzent = 0
              if (vormonatIstWert !== 0) {
                diffVormonatProzent = (diffVormonatAbsolut / vormonatIstWert) * 100
              }

              const vormonatVorzeichen = diffVormonatAbsolut >= 0 ? "+" : ""
              const vormonatFarbe = diffVormonatAbsolut >= 0 ? "#10B981" : "#EF4444" // Grün für positiv, Rot für negativ

              vormonatHtml = `
              <div style="margin-top: 8px; border-top: 1px solid #4A5568; padding-top: 8px;">
                <div style="display: flex; justify-content: space-between;">
                  <span>vs. Vormonat (Ist):</span>
                  <span style="font-weight: 600; color: ${vormonatFarbe};">
                    ${vormonatVorzeichen}${diffVormonatAbsolut.toLocaleString("de-CH")} (${vormonatVorzeichen}${diffVormonatProzent.toFixed(1)}%)
                  </span>
                </div>
              </div>
            `
            }
            // ====================================================================
            // ENDE NEUE LOGIK
            // ====================================================================

            const diffVorzeichen = differenz >= 0 ? "+" : ""
            const diffFarbe = differenz >= 0 ? "#10B981" : "#EF4444"

            // Kompletter HTML-Code für das Tooltip
            return `
            <div class="pa-2" style="font-size: 12px; min-width: 250px;">
              <div class="mb-1"><strong>${monat}</strong></div>
              <div style="display: flex; justify-content: space-between;">
                <span>Soll:</span>
                <span style="font-weight: 600;">${sollWert.toLocaleString("de-CH")}</span>
              </div>
              <div style="display: flex; justify-content: space-between;">
                <span>Ist:</span>
                <span style="font-weight: 600;">${istWert.toLocaleString("de-CH")}</span>
              </div>
              <div style="display: flex; justify-content: space-between; margin-top: 4px;">
                <span>Differenz:</span>
                <span style="font-weight: 600; color: ${diffFarbe};">
                  ${diffVorzeichen}${differenz.toLocaleString("de-CH")}
                </span>
              </div>
              ${vormonatHtml}
            </div>
          `
          },
        },
        legend: { position: "top", horizontalAlign: "left", offsetY: 10 },
      }
    },

    centerData() {
      if (Object.keys(this.centers).length === 0 || this.storeStudios.length === 0) return null

      const returnData = []
      const firstSeriesTotal = { name: "Geplant", data: [] }
      const secondSeriesTotal = { name: "IST", data: [] }
      const categories = Object.keys(this.centers[Object.keys(this.centers)[0]]).sort()
      const monthlyTotals = categories.reduce((acc, month) => ({ ...acc, [month]: { ist: 0, plan: 0 } }), {})

      for (const center in this.centers) {
        if (this.studios && this.studios.length > 0 && !this.studios.find((stud) => stud.code === center)) {
          continue
        }
        const storeCenter = this.storeStudios.find((stud) => stud.code === center)
        if (!storeCenter) continue

        const firstSeries = { name: "Geplant", data: [] }
        const secondSeries = { name: "IST", data: [] }
        let lastHabenVal = 0
        let monthData = []

        for (const month of categories) {
          const istVal = this.centers[center][month] || 0
          let planVal = lastHabenVal
          const growthData = storeCenter.growth.find((corr) => corr.date === month)
          if (growthData && lastHabenVal > 0) planVal += Number(growthData.count)

          firstSeries.data.push(planVal)
          secondSeries.data.push(istVal)
          monthlyTotals[month].ist += istVal
          monthlyTotals[month].plan += planVal
          monthData.push({ month, ist: istVal, plan: planVal })
          lastHabenVal = istVal
        }

        const istValues = monthData.map((m) => m.ist)
        const average = Math.round(istValues.reduce((a, b) => a + b, 0) / (istValues.filter((v) => v > 0).length || 1))

        const currentMonth = monthData[monthData.length - 1] || { month: "N/A", ist: 0, plan: 0 }
        const previousMonth = monthData.length > 1 ? monthData[monthData.length - 2] : { month: "N/A", ist: 0 }

        const firstMonthIst = monthData[0]?.ist || 0
        const totalGrowthValue = currentMonth.ist - firstMonthIst
        const totalGrowthPercent = this.calculatePercentageDiff(currentMonth.ist, firstMonthIst)

        const monthlyGrowthValue = currentMonth.ist - previousMonth.ist
        const monthlyGrowthPercent = this.calculatePercentageDiff(currentMonth.ist, previousMonth.ist)

        returnData.push({
          center,
          series: [firstSeries, secondSeries],
          stats: {
            average,
            monthlyGrowth: { value: monthlyGrowthValue, percent: monthlyGrowthPercent },
            previousMonth: { month: previousMonth.month, value: previousMonth.ist },
            currentMonth: {
              ist: currentMonth.ist,
              plan: currentMonth.plan,
              diffPercent: this.calculatePercentageDiff(currentMonth.ist, currentMonth.plan),
            },
            totalGrowth: { value: totalGrowthValue, percent: totalGrowthPercent },
          },
        })
      }

      const totalIstValues = []
      for (const month of categories) {
        firstSeriesTotal.data.push(monthlyTotals[month].plan)
        secondSeriesTotal.data.push(monthlyTotals[month].ist)
        totalIstValues.push(monthlyTotals[month].ist)
      }

      let totalStats = {
        average: 0,
        monthlyGrowth: { value: 0, percent: 0 },
        previousMonth: { month: "N/A", value: 0 },
        currentMonth: { ist: 0, plan: 0, diffPercent: 0 },
        totalGrowth: { value: 0, percent: 0 },
      }

      if (totalIstValues.length > 0) {
        const validTotalIst = totalIstValues.filter((v) => v > 0)
        totalStats.average = validTotalIst.length > 0 ? Math.round(validTotalIst.reduce((a, b) => a + b, 0) / validTotalIst.length) : 0

        const lastMonthTotalIst = totalIstValues[totalIstValues.length - 1]
        const lastMonthTotalPlan = firstSeriesTotal.data[firstSeriesTotal.data.length - 1]
        totalStats.currentMonth = {
          ist: lastMonthTotalIst,
          plan: lastMonthTotalPlan,
          diffPercent: this.calculatePercentageDiff(lastMonthTotalIst, lastMonthTotalPlan),
        }

        const prevMonthTotalIst = totalIstValues.length > 1 ? totalIstValues[totalIstValues.length - 2] : 0
        totalStats.previousMonth = {
          month: categories.length > 1 ? categories[categories.length - 2] : "N/A",
          value: prevMonthTotalIst,
        }

        totalStats.monthlyGrowth = {
          value: lastMonthTotalIst - prevMonthTotalIst,
          percent: this.calculatePercentageDiff(lastMonthTotalIst, prevMonthTotalIst),
        }

        const firstMonthTotalIst = totalIstValues[0] || 0
        totalStats.totalGrowth = {
          value: lastMonthTotalIst - firstMonthTotalIst,
          percent: this.calculatePercentageDiff(lastMonthTotalIst, firstMonthTotalIst),
        }
      }

      returnData.sort((a, b) => a.center.localeCompare(b.center))

      return { returnData, returnDataTotal: [firstSeriesTotal, secondSeriesTotal], categories, totalStats }
    },
  },
  watch: {
    studios() {
      console.log("test")
      this.isFiltering = true // Overlay sofort anzeigen

      // $nextTick wartet, bis die DOM-Aktualisierung (das Re-Rendering) abgeschlossen ist
      this.$nextTick(() => {
        // Erst dann wird das Overlay wieder ausgeblendet
        this.isFiltering = false
      })
    },
    async months() {
      await this.fetchContractDevelopment()
    },
  },
}
</script>

<style lang="scss" scoped>
.custom-tooltip {
  padding: 10px;
  background-color: #2b313f;
  border: 1px solid #535a6c;
  border-radius: 5px;
  color: #fff;
  font-family: sans-serif;
  font-size: 12px;
}
.custom-tooltip hr {
  border: 0;
  border-top: 1px solid #535a6c;
  margin: 5px 0;
}
.dot-planned,
.dot-actual {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 5px;
}
.dot-planned {
  background-color: #42a5f5;
}
.dot-actual {
  background-color: #ffffff;
}
</style>
